import src from "IMAGE";
export default { src, width: 604, height: 356, blurDataURL: null, blurWidth: 0, blurHeight: 0 }
